import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputAdornment from '@mui/material/InputAdornment';

import NumberInput from "./NumberInput.js";

import settingSystem from "../SettingSystem.js"

import TextManager from "../TextManager.js"

// import Switch from '@mui/material/Switch';



export default class SettingsPage extends React.Component {

	state = {
	}


	render() {

		return (

			<div className="PopupPage">
				{/*<CloseIcon sx={{float:"right", left:"100px"}}/>*/}

				<div className="PageTitle">{TextManager.getText("about")}</div>

				<List className="PageList">

					<Box sx={{
						display: "flex",
						flexDirection:  "column",
						justifyContent: "center",
						alignItems: "center",
						textAlign: "center"
					}}>

						<Typography sx={{fontWeight:"bold", fontSize:"26px"}}>{TextManager.getText("application_name")} (v1.0.0)</Typography>
						<Typography sx={{fontSize:"18px"}}>Copyright (c) Parsons Music Ltd</Typography>
						<Typography sx={{marginTop:"20px", fontSize:"18px"}}>{TextManager.getText("omr_engine_statement")}</Typography>
						<Button onClick={() => window.open("https://github.com/Audiveris/audiveris")}>{TextManager.getText("view_audiveris_info")}</Button>
					</Box>
				</List>


				<Stack spacing={2} direction="row" justifyContent="center">
					<Button onClick={
						() => {
							if (this.tempZoomLevel != null) {
								settingSystem.setSetting("zoomLevel", this.tempZoomLevel * 0.01, this);
							}

							this.props.close();
						}
					} variant="contained">{TextManager.getText("close")}</Button>
				</Stack>
			</div>
		);
	}
}